import { ContextSchema, SchemaDetail, schemaPath } from './types'

const LETTER_SCHEMA: SchemaDetail = {
  vendor: 'space.yay',
  name: 'letter',
  format: 'jsonschema',
  version: '1-0-0',
}

export type LetterContextSchemaData = {
  letter_id?: number // A letter ID
  sender_id: number // A User ID of the user who create this letter
  receiver_id: number // A User ID of the user who receiver this letter
  is_sender_follow_receiver?: boolean // A Boolean value indicate if sender follows receiver
  is_sender_follow_by_receiver?: boolean // A Boolean value indicate if sender is followed by receiver
}

export const letterContextSchema = (
  data: LetterContextSchemaData
): ContextSchema<LetterContextSchemaData> => ({
  schema: schemaPath(LETTER_SCHEMA),
  data,
})
